<div class="cell shrink grid-x grid-margin-x align-justify align-middle">

    <h1 class="_white cell auto">{{title}}</h1>

    <kiwi-animator-select-team class="cell shrink"></kiwi-animator-select-team>

    <kiwi-all-periods-selector class="cell shrink"></kiwi-all-periods-selector>

    <button (click)="onSave()" [disabled]="isDisabledSaveButton()" class="button _iconRight cell shrink">
        <span [i18nKey]="'common.action.save'"></span>
        <i class="fas fa-save"></i>
    </button>
</div>

<kiwi-closed-decisions-banner *ngIf="decisionsClosed">
</kiwi-closed-decisions-banner>
